import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const billingApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url;
  if (data?.magicToken) {
    url = `${env}${
      API_ENDPOINT.Billing.billing +
      "?magicToken=" +
      data?.magicToken +
      "&page=" +
      page +
      "&pageSize=" +
      data?.pageSize
    }`;
  } else {
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const billingApprovalApi = async (data) => {
  let url;
  if (data?.magicToken) {
    url = `${env}${
      API_ENDPOINT.Billing.billingApproval + "?magicToken=" + data?.magicToken
    }`;
  } else {
    url = `${env}${API_ENDPOINT.Billing.billingApproval}`;
  }
  const value = data?.approvalIds
    ? { approvalIds: data?.approvalIds }
    : data?.rejection;
  const res = await requestInstance
    .post(url, value)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
